import React, { useContext, createContext } from 'react';
import { useAddressSearch, AddressSearchValue } from './useAddressSearch';
import _ from 'lodash';
import { usePersonaliaForm, PersonaliaForm } from './usePersonaliaForm';

type FWAOrderContextValue = {
  addressSearch: AddressSearchValue;
  personaliaForm: PersonaliaForm;
};
const FWAOrderContext = createContext<FWAOrderContextValue | undefined>(undefined);

export const FWAOrderProvider: React.FC = props => {
  const addressSearch = useAddressSearch();
  const personaliaForm = usePersonaliaForm();
  const value = {
    addressSearch,
    personaliaForm
  };

  return <FWAOrderContext.Provider value={value}>{props.children}</FWAOrderContext.Provider>;
};

export const useFWAOrder = () => {
  const contextValue = useContext(FWAOrderContext);
  if (!contextValue) {
    throw Error(
      'No FWAOrderContext value found, this usually happens when you try to access a context outside the provider'
    );
  }
  return contextValue;
};
